<template>
  <div class="split">
    <section id="content">
      <div class="section-inner">
        <div class="element xs centered">
          <slot name="content"></slot>
        </div>
      </div>
      <div v-if="isStep" class="steps">
        <div v-bind:key="step" v-for="step in steps">
          <div :class="{'current': $route.name === step}" class="step"></div>
        </div>
      </div>
    </section>
    <section id="extra">
      <div class="section-inner">
        <div class="element small centered">
          <slot name="extra"></slot>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'onboard-wrap',
  data () {
    return {
      steps: ['signup', 'name', 'pay']
    }
  },
  computed: {
    isStep: function () {
      return this.steps.indexOf(this.$route.name) > -1
    }
  }
}
</script>

<style scoped lang="stylus" src="./onboard-wrap.styl" >



// WEBPACK FOOTER //
// src/components/onboard-wrap/onboard-wrap.vue